import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { ioteqFullscreenModule } from '@tools/components/fullscreen';
import { MapListSliderModule } from '@tools/components/map-list-slider';
import { ioteqNavigationModule } from '@tools/components/navigation';
import { LanguagesModule } from 'app/layout/common/languages/languages.module';
import { MessagesModule } from 'app/layout/common/messages/messages.module';
import { NotificationsModule } from 'app/layout/common/notifications/notifications.module';
import { SearchModule } from 'app/layout/common/search/search.module';
import { ShortcutsModule } from 'app/layout/common/shortcuts/shortcuts.module';
import { UserModule } from 'app/layout/common/user/user.module';
import { SharedModule } from 'app/shared/shared.module';
import { MaterialLayoutComponent } from 'app/layout/layouts/horizontal/material/material.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatLegacySlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MapListSliderService } from '@tools/components/map-list-slider/map-list-slider.service';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { HeaderModule } from '@tools/components/header/header.module'
import { DisplayBulletinsModule } from '@tools/components/display-bulletins/display-bulletins.module';


@NgModule({
    declarations: [
        MaterialLayoutComponent
    ],
    providers: [
        MapListSliderService,
        AngularFirestoreModule
    ],
    imports     : [
        HttpClientModule,
        RouterModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        MatLegacySlideToggleModule,
        ioteqFullscreenModule,
        MapListSliderModule,
        ioteqNavigationModule,
        LanguagesModule,
        MessagesModule,
        NotificationsModule,
        SearchModule,
        ShortcutsModule,
        UserModule,
        SharedModule,
        FlexLayoutModule,
        HeaderModule,
        DisplayBulletinsModule
    ],
    exports     : [
        MaterialLayoutComponent
    ]
})
export class MaterialLayoutModule
{
}
